"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTrackingLog = exports.trackingLog = exports.errorLog = exports.getLogParams = exports.campaignId = exports.getLogId = void 0;
const firestore_react_1 = require("comodel/firestore-react");
const auth_1 = require("firebase/auth");
const firestore_1 = require("firebase/firestore");
const firebase_app_1 = __importDefault(require("common/firebase-app"));
const auth_2 = require("common/auth");
const react_1 = require("react");
const crypto_1 = require("utils/crypto");
const firestore = (0, firestore_1.getFirestore)(firebase_app_1.default);
const auth = (0, auth_1.getAuth)(firebase_app_1.default);
const getRandomHexString = (length) => {
    return Array.from(crypto.getRandomValues(new Uint8Array(length)))
        .map((d) => d.toString(16).padStart(2, "0"))
        .join("");
};
const getLogId = () => {
    return getRandomHexString(16);
};
exports.getLogId = getLogId;
const getWithDefault = (storage, key, generator) => {
    const value = storage.getItem(key);
    if (value) {
        return value;
    }
    else {
        const defaultValue = generator();
        storage.setItem(key, defaultValue);
        return defaultValue;
    }
};
const pageId = (0, exports.getLogId)();
const deviceId = (() => {
    return getWithDefault(localStorage, "deviceId", exports.getLogId);
})();
const searchParamSessionId = new URLSearchParams(window.location.search).get("sessionId") || undefined;
let sessionId = (() => {
    if (searchParamSessionId) {
        sessionStorage.setItem("sessionId", searchParamSessionId);
        return searchParamSessionId;
    }
    else {
        return getWithDefault(sessionStorage, "sessionId", exports.getLogId);
    }
})();
const resetSessionId = () => {
    sessionId = searchParamSessionId || (0, exports.getLogId)();
    sessionStorage.setItem("sessionId", sessionId);
};
const searchParamCampaignId = new URLSearchParams(window.location.search).get("campaignId") || undefined;
exports.campaignId = (() => {
    if (searchParamCampaignId) {
        sessionStorage.setItem("campaignId", searchParamCampaignId);
        return searchParamCampaignId;
    }
    else {
        return sessionStorage.getItem("campaignId");
    }
})();
const getLogParams = () => {
    return {
        pageId,
        sessionId,
        deviceId,
        campaignId: exports.campaignId,
    };
};
exports.getLogParams = getLogParams;
const errorLog = (error, info) => {
    const errorObject = error instanceof Error
        ? {
            name: error.name,
            message: error.message,
            stack: error.stack || "",
            componentStack: info === null || info === void 0 ? void 0 : info.componentStack,
            internalMessage: info === null || info === void 0 ? void 0 : info.internalMessage,
            userMessage: info === null || info === void 0 ? void 0 : info.userMessage,
        }
        : {
            name: "Unknown",
            message: JSON.stringify(error),
            stack: "",
            componentStack: info === null || info === void 0 ? void 0 : info.componentStack,
            internalMessage: info === null || info === void 0 ? void 0 : info.internalMessage,
            userMessage: info === null || info === void 0 ? void 0 : info.userMessage,
        };
    const errorHash = (0, crypto_1.getHashSHA256)(JSON.stringify(errorObject));
    const logId = (0, exports.getLogId)();
    const logHash = logId.slice(0, 8);
    console.error((info === null || info === void 0 ? void 0 : info.internalMessage) || "error", error);
    console.error(Object.assign(Object.assign({}, errorObject), { errorHash, logId, logHash }));
    // lazy execute
    errorLogRaw(logId, Object.assign({ errorHash,
        logHash }, errorObject)).catch(console.error);
    return Object.assign(Object.assign({}, errorObject), { errorHash,
        logId,
        logHash });
};
exports.errorLog = errorLog;
const errorLogRaw = (logId, data) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    const claims = (_b = (yield ((_a = auth.currentUser) === null || _a === void 0 ? void 0 : _a.getIdTokenResult()))) === null || _b === void 0 ? void 0 : _b.claims;
    yield (0, firestore_1.setDoc)((0, firestore_1.doc)(firestore, `/errorLogs/${logId}`), (0, firestore_react_1.cleanObject)(Object.assign({ type: "react", createdAt: Date.now(), userAgent: navigator.userAgent, location: location.href, userId: (_c = auth.currentUser) === null || _c === void 0 ? void 0 : _c.uid, email: (_d = auth.currentUser) === null || _d === void 0 ? void 0 : _d.email, deviceId,
        sessionId,
        claims }, data)));
});
const trackingLog = (type, data) => __awaiter(void 0, void 0, void 0, function* () {
    var _e, _f;
    try {
        const logId = (0, exports.getLogId)();
        const prevLogId = sessionStorage.getItem("prevLogId");
        sessionStorage.setItem("prevLogId", logId);
        yield (0, firestore_1.setDoc)((0, firestore_1.doc)(firestore, `/trackingLog/${logId}`), (0, firestore_react_1.cleanObject)(Object.assign({ type, createdAt: Date.now(), userAgent: navigator.userAgent, location: location.href, userId: (_e = auth.currentUser) === null || _e === void 0 ? void 0 : _e.uid, email: (_f = auth.currentUser) === null || _f === void 0 ? void 0 : _f.email, deviceId,
            sessionId,
            prevLogId,
            pageId }, data)));
    }
    catch (e) {
        console.error("error in trackingLog");
        console.error(e);
    }
});
exports.trackingLog = trackingLog;
const useTrackingLog = (type, data, disable) => {
    const { user, loading } = (0, auth_2.useAdminAuthentication)();
    const isFirstTime = (0, react_1.useRef)(true);
    (0, react_1.useMemo)(() => {
        if (!disable && !loading && isFirstTime.current) {
            isFirstTime.current = false;
            // if (initializeSession) {
            //   resetSessionId();
            // }
            (0, exports.trackingLog)(type, Object.assign({ userId: user === null || user === void 0 ? void 0 : user.uid, email: user === null || user === void 0 ? void 0 : user.email }, data));
        }
    }, [loading]);
};
exports.useTrackingLog = useTrackingLog;
